<template>
  <div id="app">
    <el-row v-show="isLoggedin">
      <el-col :span="24">
        <el-container>
          <el-header style="border-bottom: 1px solid #c5c5ca;">
            <Logout/>
          </el-header>
          <el-container>
            <el-aside>
              <Menu/>
            </el-aside>
            <el-main>
              <!--<el-page-header v-bind:content="pageHeaderText"></el-page-header>-->
              <router-view></router-view>
            </el-main>
          </el-container>
        </el-container>
      </el-col>
    </el-row>
    <div v-show="!isLoggedin">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import * as types from './store/types'
import { mapState } from 'Vuex'
import Logout from './components/Logout'
import Menu from './components/Menu'

export default {
  name: 'App',
  components: {
    Logout,
    Menu
  },
  computed: mapState({
    isLoggedin: state => state.isLoggedin
  }),
  data () {
    return {
      pageHeaderText: this.$router.name
    }
  },
  methods: {
    logout () {
      this.$store.commit(types.LOGOUT)
      this.$router.push({ path: '/login' })
    }
  }
}
</script>

<style>
  body{
    /*background-color: #eaf4ff;*/
    background-color: #f8f3f4;
  }
  #app {
    /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
    /* font-family: Calibri, san-serif; */
    font-family: Century Gothic, CenturyGothic, AppleGothic, sans-serif;
    /* font-family: Dejavu Sans, Arial, Verdana, sans-serif; */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  .el-header, .el-footer {
    /*background-color: #85C1E9;*/
    background-color: #f8f3f4;
    /*color: rgba(255, 255, 255, .87);*/
    text-align: center;
    line-height: 60px;
  }

  .el-aside {
/*    background-color: #D3DCE6;
    color: #333;*/
    text-align: left;
    line-height: 20px;
    height: 100%;
    margin-top: 25px;
  }

  .el-main {
    /*background-color: #eaf4ff;*/
    background-color: #f8f3f4;
    color: #333;
    text-align: center;
  }

  body > .el-container {
    margin-bottom: 40px;
  }

  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }

  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }
  .el-menu {
    border-right: none;
  }

  .text-align-left{
    text-align: left;
  }
  .text-align-right{
    text-align: right;
  }
  .right{
    float: right;
  }
  .el-menu-item.is-active {
    color: #358820;
    background-color: #99c0ac;
  }
  .el-menu-item:focus, .el-menu-item:hover {
    background-color: #dae4ef;
  }
</style>



// WEBPACK FOOTER //
// App.vue?a215f3a8